import React from 'react';
import Kicks from './components/kicks/Kicks'
import './App.css';

function App() {
  return (
    <div className="App">
      <Kicks />
    </div>
  );
}

export default App;
